import styled from 'styled-components';

const StyledContainer = styled.div<{ $hidden: boolean }>`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
	pointer-events: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};
	transition: opacity 0.3s ease-in-out;
`;

export { StyledContainer };
